module.exports = __webpack_public_path__ + "static/media/cards.beb888b0.svg";